import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIConstants } from '../../../../_config/restapis';
import { map } from 'rxjs/operators';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class APIConsentService {

    constructor(
        private http: HttpClient,
        private db: $DBManagerService,
        private evt: $BroadcastManagerService
    ) { }

	
	public getBulkConsentSummary(entityId,userRole): Observable<any> {
        return this.http.get(APIConstants.GETBULKCONSENTSUMMARY+ '/'+entityId+ '/'+userRole);

    } 
	
    public downloadConsentFile(data): Observable<any> {
        return this.http.post(APIConstants.DOWNLOADCONSENTFILE,data,{responseType: "blob"});

    }
	public getConsentSummaryFilter(data): Observable<any> {
        console.log("data ",data);
        return this.http.post(APIConstants.GETCONSENTSUMMARYFILTER,data);

    }
	

        public GetQueryTemplateId(data): Observable<any> {
            return this.http.get(APIConstants.GETQUERYTEMPLATEIDS +'/'+ data);  
        }
		
		        //BulkConsentUpload
		public bulkConsentUpload(data: any): Observable<any> {   
            console.log("serive file ------------- ",data);    
            return this.http.post(APIConstants.BULKCONSENTUPLOAD , data);        
        }
		
		public checkConsentMigFileStatus(data: any): Observable<any> {   
            console.log("serive file ------------- ",data);    
            return this.http.get(APIConstants.CHECKCONSENTMIGFILESTS +'/'+ data);        
        }
        public checkIPOnLoad(data: any): Observable<any> {       
            return this.http.post(APIConstants.CHECKIPONLOAD, data);        
        }
	
        public verifycst(data): Observable<any> {
            return this.http.post(APIConstants.VERIFYCST, data);  
        }   
        public linkcst(data): Observable<any> {
              return this.http.post(APIConstants.LINKCST, data);  
       }
       
public verifyCstID(data): Observable<any> {
    return this.http.post(APIConstants.VERIFYCSTID, data);
}

public acquireCSRegthruPage(data): Observable<any> {
    return this.http.post(APIConstants.ACQUIRECSREGTHRUPAGE, data);
}

public acquireCSRegthruQR(data): Observable<any> {
    return this.http.post(APIConstants.ACQUIRECSREGTHRUQR, data);
    
}

public CSRegthruQR(data): Observable<any> {
    return this.http.post(APIConstants.CONSENTQR, data);
    
}
public processQRCd(constempid): Observable<any> {
    return this.http.get(APIConstants.PROCESSQRCD + '?constempid='+ constempid);

}

public submitconsentforqrcd(data): Observable<any> {
    return this.http.post(APIConstants.SUBMITCONSENTFORQRCD, data);
    
}

public summaryFilter(data): Observable<any> {
    console.log("data ",data);
    return this.http.post(APIConstants.SUMMARYFILTER,data);

}

public exportconsentstatussummaryCSV(data): Observable<any> {
    // return this.http.post(APIConstants.DOWNLOADCONSENTSTATUSSUMMARYEXCEL, data, { responseType: "blob" });
    return this.http.post(APIConstants.DOWNLOADCONSENTSTATUSSUMMARYEXCEL, data);
}

//Digital Consent
public fetchcreditbalance(data): Observable<any> {
    console.log("data ",data);
    return this.http.post(APIConstants.FETCHCREDITBALANCE,data);

}

public digitalConsentFilter(data:any): Observable<any> {
    console.log("data ",data);
    return this.http.post(APIConstants.RECHARGESUMMARYFILTER,data);

}

public getratecard(): Observable<any> {
    return this.http.post(APIConstants.GETRATECARD,{});

}

public buyratecard(data): Observable<any> {
    return this.http.post(APIConstants.BUYRATECARD,data);  
}

public fetchCSTID(data): Observable<any> {
    return this.http.post(APIConstants.FETCHCSTID,data);  
}
       
}